import {Flex, Text, Title} from 'exsportia-components'
import {FC, ReactElement} from 'react'

import {Button} from '../../ui/components/button/button'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'
import {ChangePhoneFlow} from '../change-phone-flow/change-phone-flow'
import {UserExsportiaCard} from '../user-exsportia-card/user-exsportia-card'

export type UserExsportiaCardModalProps = {
  name: string
  subText: string
  handleOpenQr?: (() => void) | null
  withDescription?: boolean
  avatar?: ReactElement | string | null
  phone?: string
  phoneClaimed?: boolean
  viewOnly?: boolean
}

const textSettings = {
  textAlign: 'center',
}

export const UserExsportiaCardModal: FC<UserExsportiaCardModalProps> = ({name, subText, avatar, withDescription, handleOpenQr, phone, phoneClaimed, viewOnly}) => {
  const {l} = useLocale()
  const {closeModal} = useModalActions()

  return (
    <Flex
      flexDirection='column'
      gap='16px'
      mb='24px'
    >
      <UserExsportiaCard
        name={name}
        avatar={avatar}
        subText={subText}
        handleOpenQr={handleOpenQr}
      />

      <Flex flexDirection='column' gap='8px' p='16px' border='1px solid #eee' borderRadius='12px'>
        <ChangePhoneFlow currentPhone={phone || ''} phoneClaimed={phoneClaimed} viewOnly={viewOnly} />
      </Flex>

      {withDescription && (
        <>
          <Title
            styleType='h2'
            settings={textSettings}
            text={l('oneAccountToAccess')}
          />
          <Text text={l('oneAccountDescription')} settings={textSettings} />
        </>
      )}
      <Button onClick={closeModal} type='flat'>{l('close')}</Button>
    </Flex>
  )
}
